/* ============================================================
   LA FABRIQUE DES MINIS — interface commune
   Bandeau, en-tête collant, megamenus, tiroir mobile,
   révélation au scroll, accordéons, ancres, toast.
   Chaque module se tait si son markup est absent.
   ============================================================ */
(function () {
  'use strict';
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.LFDM = window.LFDM || {};

  /* ---------- toast ---------- */
  var toastT;
  LFDM.toast = function (txt) {
    var t = $('#lfdmToast');
    if (!t) return;
    $('#lfdmToastTxt').textContent = txt;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  };

  /* ---------- bandeau d'annonce ---------- */
  var announceTimer = null;
  function announce() {
    var bar = $('#lfdmAnnounce');
    if (!bar) return;
    /* l'éditeur recharge la section : on ne réinitialise qu'une fois par bandeau */
    if (bar.getAttribute('data-announce-ready') === '1') return;
    bar.setAttribute('data-announce-ready', '1');

    var editing = bar.getAttribute('data-announce-editor') === 'true' ||
                  (window.Shopify && window.Shopify.designMode);

    /* déjà masqué par le client pendant cette visite */
    if (!editing) {
      try {
        if (sessionStorage.getItem('lfdm-announce') === 'off') { bar.remove(); return; }
      } catch (e) {}
    }

    var msgs = $$('.announce-msg', bar), i = 0;
    var delay = parseInt(bar.getAttribute('data-announce-delay'), 10);
    if (!delay || delay < 1000) delay = 5000;
    clearInterval(announceTimer);
    if (msgs.length > 1 && !RM) {
      announceTimer = setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, delay);
    }

    var close = $('[data-announce-close]', bar);
    if (close) close.addEventListener('click', function () {
      bar.style.height = bar.offsetHeight + 'px';
      requestAnimationFrame(function () {
        bar.style.transition = 'height .4s var(--ease), opacity .3s';
        bar.style.height = '0';
        bar.style.opacity = '0';
        bar.style.overflow = 'hidden';
      });
      try { sessionStorage.setItem('lfdm-announce', 'off'); } catch (e) {}
    });
  }

  /* ---------- en-tête et megamenus ---------- */
  function header() {
    var head = $('#lfdmHeader');
    if (!head) return;
    var onScroll = function () { head.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var veil = $('#lfdmMegaVeil');
    var triggers = $$('.lfdm-nav a.has-mega', head);
    if (!triggers.length) return;
    var open = null, closeT = null;
    var wide = function () { return window.matchMedia('(min-width:1000px)').matches; };

    function show(key) {
      clearTimeout(closeT);
      if (open === key) return;
      hide(true);
      var panel = document.getElementById('mega-' + key);
      if (!panel) return;
      panel.classList.add('is-open');
      if (veil) veil.classList.add('is-on');
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', String(t.getAttribute('data-mega') === key));
      });
      open = key;
    }
    function hide(now) {
      clearTimeout(closeT);
      var done = function () {
        $$('.mega', head).forEach(function (m) { m.classList.remove('is-open'); });
        if (veil) veil.classList.remove('is-on');
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        open = null;
      };
      if (now) done(); else closeT = setTimeout(done, 180);
    }
    LFDM.closeMega = hide;

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-mega');
      t.addEventListener('mouseenter', function () { if (wide()) show(key); });
      t.addEventListener('focus', function () { show(key); });
      t.addEventListener('click', function (e) {
        if (open === key) { hide(true); return; }   // deuxième tape : on suit le lien
        e.preventDefault();
        show(key);
      });
    });
    $$('.lfdm-nav, .mega', head).forEach(function (el) {
      el.addEventListener('mouseleave', function () { hide(); });
      el.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    });
    if (veil) veil.addEventListener('click', function () { hide(true); });
    $$('.mega a', head).forEach(function (a) {
      a.addEventListener('click', function () { hide(true); });
    });
    window.addEventListener('scroll', function () { if (open) hide(true); }, { passive: true });
  }

  /* ---------- tiroir mobile ---------- */
  function drawer() {
    var d = $('#lfdmDrawer');
    if (!d) return;
    var openBtn = $('[data-drawer-open]');
    var lock = function (on) { document.body.style.overflow = on ? 'hidden' : ''; };
    if (openBtn) openBtn.addEventListener('click', function () { d.classList.add('is-open'); lock(true); });
    $$('[data-drawer-close]', d).forEach(function (el) {
      el.addEventListener('click', function () { d.classList.remove('is-open'); lock(false); });
    });
    $$('.d-acc', d).forEach(function (x) {
      x.addEventListener('toggle', function () {
        if (x.open) $$('.d-acc', d).forEach(function (o) { if (o !== x) o.open = false; });
      });
    });
    LFDM.closeDrawer = function () { d.classList.remove('is-open'); lock(false); };
  }

  /* ---------- révélation au scroll ---------- */
  function reveal() {
    var els = $$('.rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || RM) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- accordéons : un seul ouvert par groupe ---------- */
  function accordions() {
    $$('[data-acc-group]').forEach(function (group) {
      var items = $$('details', group);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- ancres avec compensation de l'en-tête ---------- */
  function anchors() {
    $$('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (!id || id === '#' || id.length < 2) return;
        var t = document.querySelector(id);
        if (!t) return;
        e.preventDefault();
        var head = $('#lfdmHeader');
        var off = (head ? head.offsetHeight : 0) + 18;
        window.scrollTo({
          top: t.getBoundingClientRect().top + window.scrollY - off,
          behavior: RM ? 'auto' : 'smooth'
        });
      });
    });
  }

  /* ---------- Échap ferme tout ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (LFDM.closeMega) LFDM.closeMega(true);
    if (LFDM.closeDrawer) LFDM.closeDrawer();
    if (LFDM.closeCart) LFDM.closeCart();
  });

  function init() {
    announce(); header(); drawer(); reveal(); accordions(); anchors();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* l'éditeur de thème recharge les sections : on réinitialise */
  document.addEventListener('shopify:section:load', init);
})();
